import { Component, OnInit, Inject, AfterContentInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import { MatButtonToggleGroup } from '@angular/material/button-toggle';
import { EventService } from '../../../services/event.service';
import { PlayerService } from '../../../services/player.service';
import { Group } from '../../../objects/group';
import { Router } from '@angular/router';
import { EventInfo } from '../../../objects/EventInfo';
import { ScrollToService } from '../../../services/scroll-to.service';
import { HttpErrorResponse } from '../../../../../node_modules/@angular/common/http';
import { CoursesService } from 'src/app/services/courses.service';


@Component({
  selector: 's18-new-event-dialog',
  templateUrl: './new-event-dialog.component.html',
  styleUrls: ['./new-event-dialog.component.scss']
})
export class NewEventDialogComponent implements OnInit, AfterContentInit {
  @ViewChild('nbrOfHolesGroup', { static: true }) nbrOfHoles: MatButtonToggleGroup;
  sendingRequest = false;

  bubble = { top: -500, left: -500, visible: false };
  searchingCourse: boolean = false;
  searchingTees: boolean = false;

  date: string;
  time: string;
  eventName: string;
  eventState: string;
  eventCourseId: string;
  eventTeesId: string;
  eventGroupId: string;
  eventScoring: string;
  isMultiRound: boolean = false;
  isRyderCup: boolean = false;
  eventGroup: Group;
  masterEventId: string;
  error: string = '';
  availEventScoring: { id: string, name: string }[];
  isStepTwo: boolean = false;
  snackbarRef: MatSnackBarRef<SimpleSnackBar>;


  disabled = {
    group: false,
    date: false,
    course: false,
    scoring: false
  };


  allGroups: Group[];

  allStates: { state: string };
  courses: { coursename: string, course_id: string };
  tees: { teename: string, tees_id: string };

  constructor(
    private dialog: MatDialog,
    private snackbar: MatSnackBar,
    private dialogRef: MatDialogRef<NewEventDialogComponent>,
    private eventService: EventService,
    private playerService: PlayerService,
    private courseService: CoursesService,
    private scrollToService: ScrollToService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (this.data.isStepTwo) {
      this.isStepTwo = true;
    }
    if (this.data.date) {
      this.date = this.data.date;
      this.disabled.date = true;
    }
    var timeNow = new Date(Date.now());
    if (this.data.group_id) {
      this.eventGroupId = this.data.group_id;
      this.disabled.group = true;
      this.getEventScoring();
    }

    if (this.data.master_event_id) {
      this.masterEventId = this.data.master_event_id;
      this.eventName = "Round " + this.data.event_count;
    }

    if (this.data.course_id) {
      this.eventCourseId = this.data.course_id;
      this.eventState = this.data.state;
      this.getCourses();
      this.getTees();
      this.disabled.course = true;
    }
    timeNow.setSeconds(0);
    this.time = timeNow.toTimeString().split(' ')[0];
    this.courseService.getStates(this.data.player_id).subscribe(resp => this.parseStates(resp));
    this.playerService.getAdminGroups(this.data.player_id).subscribe(resp => {
      this.allGroups = JSON.parse(resp.d).groups;
      if (this.eventGroupId) {
        this.eventGroup = this.allGroups.find(x => +x.group_id === +this.eventGroupId);
      }
    });

    return;
  }

  ngOnInit() {
    this.nbrOfHoles.value = "18";
  }

  ngAfterContentInit() {
    var self = document.documentElement.getElementsByTagName('s18-new-event-dialog')[0];
    var dialogRect = self.getBoundingClientRect();

    if (!self) {
      return;
    }
    this.bubble.left = dialogRect.right - 100;
    this.bubble.top = (dialogRect.top - dialogRect.height / 2 - 200);
    this.bubble.top = this.bubble.top < 0 ? 0 : this.bubble.top;
    this.bubble.visible = this.showIntro();
  }


  showIntro(): boolean {
    return this.playerService.accountCreatedToday();
  }

  addRoundToMultiRound(): boolean {
    if (this.masterEventId) {
      return true;
    }
    return false;
  }

  toggleMultiRound() {
    this.isMultiRound = !this.isMultiRound;
    if (!this.isMultiRound) {
      this.isRyderCup = false;
    }
  }

  toggleRyderCup() {
    this.isRyderCup = !this.isRyderCup;
    if (this.isRyderCup) {
      this.isMultiRound = true;
    }
  }

  getCourses() {
    this.searchingCourse = true;
    this.scrollToService.scrollTo({ target: '#pick-course' });
    this.courseService.getCoursesForState(this.eventState)
      .subscribe(resp => {
        this.courses = JSON.parse(resp.d).courses;
        this.searchingCourse = false;
      }, err => {
        this.searchingCourse = false;
      });
  }

  getTees() {
    this.searchingTees = true;
    this.scrollToService.scrollTo({ target: '#pick-tees' });
    this.courseService.getTeesForCourse(this.eventCourseId)
      .subscribe(resp => {
        this.tees = JSON.parse(resp.d).tees;
        this.searchingTees = false;
      }, err => {
        this.searchingTees = false;
      });
  }

  getEventScoring() {
    this.eventService.getAvailableEventScoring(this.eventGroupId).subscribe(resp => {
      this.availEventScoring = JSON.parse(resp.d).scoring;
      this.disabled.scoring = false;
    });
  }

  parseStates(resp: any) {
    this.allStates = JSON.parse(resp.d).states;
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  onSelectGroup(): void {
    this.eventGroup = this.allGroups.find(x => +x.group_id === +this.eventGroupId);
    this.eventName = this.eventGroup.group_name + " Event";
    this.getEventScoring();
  }

  showSnackbar(guid, text) {
    if (this.sendingRequest) {
      if (text === '') {
        text = "Creating groups and tee times for this round, depending on the number of players, this could take a minute...";
      }
      this.snackbarRef = this.snackbar.open(text, null, { duration: 5000 });
      this.snackbarRef.afterDismissed()
        .subscribe(() => {
          this.checkStatus(guid);
        });
    }
  }

  checkStatus(guid) {
    this.eventService.getProcessStatus(guid)
      .subscribe(resp => {
        var status = JSON.parse(resp.d).status;
        this.showSnackbar(guid, status);
      });
  }

  newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  createEvent(): void {
    this.sendingRequest = true;

    if (this.isMultiRound) {
      this.eventService.createMultiRoundEvent(this.date, this.time, this.eventName, this.eventGroup.group_id.toString(), this.isRyderCup ? "1" : "0")
        .subscribe(resp => this.eventCreated(resp), error => this.eventError(error));
    } else if (this.addRoundToMultiRound()) {
      var guid = this.newGuid();
      this.eventService.addEventToMultiRound(this.masterEventId, this.date, this.time, this.eventName, this.eventGroup.group_id.toString(), this.eventCourseId, this.eventTeesId, this.eventScoring, guid)
        .subscribe(resp => this.eventCreated(resp), error => this.eventError(error));
      this.showSnackbar(guid, '');
    } else {
      this.eventService.createEvent(this.date, this.time, this.eventName, this.eventGroup.group_id.toString(), this.eventCourseId, this.eventTeesId, this.eventScoring, this.nbrOfHoles.value)
        .subscribe(resp => this.eventCreated(resp), error => this.eventError(error));
    }
  }

  eventCreated(resp: any): void {
    this.sendingRequest = false;
    if (this.snackbarRef) {
      this.snackbarRef.dismiss();
    }
    let newEventData: EventInfo = JSON.parse(resp.d).event_info;
    this.dialogRef.close(newEventData);
  }

  eventError(errorResponse: HttpErrorResponse) {

    console.log("Message:", errorResponse.error.Message);
    this.error = errorResponse.error.Message;
    this.sendingRequest = false;
  }

  checkDate() {
  }

  hasError() {
    if (this.error.length > 0) {
      return true;
    }
    return false;
  }
}
